/*------------------------------------*\
    modal
\*------------------------------------*/
module.exports = function(){

    var $modalTrigger = $('.js-modal-trigger');
    var $modal = $('.js-modal');
    var $modalClose = $('.js-modal-close');
    var $modalLoginContext = $('[js-login-context-text]');



    function openModal(modalID, context, redirectURL){

        if (redirectURL) {
            //location.hash = 'redirect='+redirectURL;
            Cookies.set('LOGIN_SIGNUP_REDIRECT_URI', redirectURL);
        }


        if($('.is-open--modal').length == 0) {
            $('.html').toggleClass('is-open--modal');
        }

        if($('.is-active').length != 0) {
            $modal.not($(this)).removeClass('is-active');
        }


        if (context) {
            $modalLoginContext.removeClass('u-hidden');
            $modalLoginContext.text(context);
        } else {
            $modalLoginContext.addClass('u-hidden');
        }


        $('.js-modal[data-modal="' + modalID + '"]').addClass('is-active');
        var $modalHeight = $('.js-modal.is-active').outerHeight();
        $('.modal').animate({height: ($modalHeight + 80)}, 200); // Add extra pixels for top and bottom padding



        // Pause the slider
        if (typeof homeSwiper !== 'undefined') {
            homeSwiper.stopAutoplay();
        }



    }




    function closeModal(){

        $('.html').removeClass('is-open--modal');
        $modal.removeClass('is-active');

        // unpause slider
        if (typeof homeSwiper !== 'undefined') {
            homeSwiper.startAutoplay();
        }

        $modalLoginContext.addClass('u-hidden');
    }



    $modalTrigger.on('click', function(e) {
        e.preventDefault();
        var modalID = $(this).prop('hash').split('#')[1];
        var modalContext = $(this).attr('data-modal-context') ? $(this).attr('data-modal-context') : false;
        openModal(modalID, modalContext);
    });



    $('.js-page-cover').click(function() {
        closeModal();
    });

    $modalClose.on('click', function() {
        closeModal();
    });




    window.openLoginModalWithText = function(context, redirectURL){
        openModal('login', context, redirectURL);
    };

    window.openModalWithText = function(modal, context, redirectURL){
        openModal(modal, context, redirectURL);
    };


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/modal.js